<template>
  <div class="supplier-contract-preview-container">
    <el-alert
      v-if="error"
      :title="error"
      type="error"
      :closable="false"
      show-icon>
    </el-alert>

    
    <div v-if="loading" class="loading-container">
      <el-skeleton animated :rows="10" />
    </div>
    
    <div v-else class="contract-content">
      <!-- 合同标题 -->
      <h2 class="contract-title">{{ contractInfo.title }}</h2>
      
      <!-- 合同清单标题 -->
      <div class="section-title">
        <h3>合同清单</h3>
      </div>
      
      <!-- 合同商品明细表格 -->
      <div class="table-container">
        <table class="contract-table">
          <thead>
            <tr>
              <th>分类</th>
              <th>序号</th>
              <th>材料名称</th>
              <th>规格型号</th>
              <th>单位</th>
              <th>数量</th>
              <th>税前单价<br>(元)</th>
              <th>税率</th>
              <th>含税单价<br>(元)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in contractItems" :key="item.index">
              <td>{{ item.category }}</td>
              <td>{{ item.index }}</td>
              <td>{{ item.material_name }}</td>
              <td>{{ item.spec_model }}</td>
              <td>{{ item.unit }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.unit_price }}</td>
              <td>{{ formatTaxRate(item.tax_rate) }}</td>
              <td>{{ item.tax_price }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!-- 基本信息标题 -->
      <div class="section-title">
        <h3>基本信息</h3>
      </div>
      
      <!-- 基本信息内容 -->
      <div class="info-container">
        <table class="info-table">
          <tr>
            <td class="info-label">供应商名称</td>
            <td class="info-value">{{ contractInfo.supplier_name || '未设置' }}</td>
            <td class="info-label">交货时间</td>
            <td class="info-value">{{ contractInfo.delivery_time }}</td>
            <td class="info-label">计价方式</td>
            <td class="info-value">{{ contractInfo.pricing_method }}</td>
          </tr>
          <tr>
            <td class="info-label">结算时间</td>
            <td class="info-value">{{ contractInfo.settlement_time }}</td>
            <td class="info-label">付款方式</td>
            <td class="info-value">{{ contractInfo.payment_method }}</td>
            <td class="info-label">是否计息</td>
            <td class="info-value">{{ contractInfo.is_interest }}</td>
          </tr>
          <tr>
            <td class="info-label">计息条件</td>
            <td class="info-value" colspan="5">{{ contractInfo.interest_condition }}</td>
          </tr>
          <tr v-if="contractInfo.total_amount">
            <td class="info-label">合同金额</td>
            <td class="info-value" colspan="5">{{ contractInfo.total_amount }}</td>
          </tr>
        </table>
      </div>
    </div>
    
    <!-- 底部操作按钮 -->
    <div class="action-buttons">
      <el-button 
        v-if="contractStatus === 'ACTIVE' && !isCreator"
        @click="confirmContract" 
        type="success">确认合同</el-button>
      <el-button @click="goBack" type="primary">返回</el-button>
      <el-button v-permission="'contracts:contract-view:print'" @click="printContract" type="primary" plain>打印</el-button>
    </div>
  </div>
</template>

<script>
import { getContractById, updateContractStatus } from '@/api/modules/contracts.js';
import { getUserInfo } from '@/utils/auth.js';
import { installPlatformPrintFooter } from '@/utils/print-footer';

export default {
  name: 'SupplierContractConfirm',
  data() {
    return {
      contractId: null,
      contractStatus: '',
      contractInfo: {
        title: '',
        supplier_name: '',
        delivery_time: '',
        settlement_time: '',
        payment_method: '',
        interest_condition: '',
        pricing_method: '',
        total_amount: '',
        is_interest: ''
      },
      contractItems: [],
      loading: true,
      error: null,
      showDebug: false,
      apiResponse: '无',
      apiError: '无',
      currentUser: null,
      contractCreatorId: null,
      isCreator: false
    };
  },
  created() {
// 获取当前用户信息
    this.currentUser = getUserInfo();
// 获取路由参数中的合同ID
    this.contractId = this.$route.params.id;
    if (this.contractId) {
this.fetchContractData(this.contractId);
    } else {
      console.error('合同ID不存在');
      this.error = '合同ID不存在，无法获取合同详情';
    }
  },
  methods: {
    // 重试获取数据
    retryFetch() {
this.fetchContractData(this.contractId);
    },
    
    // 获取合同详情
    fetchContractData(id) {
      if (!id) {
        this.error = '合同ID不存在，无法获取合同详情';
        this.loading = false;
        return;
      }
      
      // 对于新建的合同，使用特殊处理
      if (id === 'new') {
        this.error = '新建合同尚未保存，无法预览详情';
        this.loading = false;
        return;
      }
      
      this.loading = true;
      this.error = null;
// 使用新的统一API获取数据
      getContractById(id)
        .then(response => {
this.apiResponse = JSON.stringify(response.data, null, 2);
          
          if (response.data && response.data.success) {
            const contractData = response.data.data;
// 添加调试输出，检查供应商名称字段
// 完整输出supplier对象
            
            
            // 检查付款方式相关字段
// 检查计息条件相关字段
try {
              // 保存合同状态 
              this.contractStatus = contractData.status || '';
// 保存合同创建者ID，并检查是否为当前用户创建的合同
              this.contractCreatorId = contractData.creatorId || contractData.create_id;
              
              // 检查当前用户是否为合同创建者
              if (this.currentUser && this.contractCreatorId) {
                const currentUserId = this.currentUser.id || this.currentUser.userId || this.currentUser.unit_id || this.currentUser.unitId;
                this.isCreator = currentUserId == this.contractCreatorId; // 使用==而不是===，因为可能类型不同（字符串vs数字）
}
              
              // 从contractParties中提取供应商信息
              let supplierName = '';
              if (contractData.contractParties && contractData.contractParties.length > 0) {
                // 对于销售合同，如果partyType是CUSTOMER，则从creator中获取供应商名称
                const customerParty = contractData.contractParties.find(party => party.partyType === 'CUSTOMER');
                if (customerParty && customerParty.creator) {
                  supplierName = customerParty.creator.unitName || '';
                } else {
                  // 否则按原逻辑查找SUPPLIER类型的参与方
                  const supplier = contractData.contractParties.find(party => party.partyType === 'SUPPLIER');
                  if (supplier) {
                    supplierName = supplier.unitInfo?.unitName || '';
                  }
                }
              }
              
              // 格式化交付时间
              let deliveryTime = '';
              if (contractData.contractDate) {
                deliveryTime = contractData.contractDate.split('T')[0];
              }
              
              // 设置合同基本信息
              this.contractInfo = {
                title: contractData.contractName || '供应商合同',
                supplier_name: supplierName,
                delivery_time: deliveryTime,
                settlement_time: contractData.settlement_method || contractData.settlementMethod || '',
                payment_method: this.formatPaymentMethod(contractData),
                interest_condition: this.formatInterestCondition(contractData),
                pricing_method: this.formatPricingMethod(contractData.pricingMethod) || contractData.pricing_method || '',
                total_amount: contractData.contractAmount || contractData.total_amount || '',
                is_interest: contractData.interestCalculation ? '是' : (contractData.is_measured === '1' || contractData.is_measured === 1 ? '是' : '否')
              };
              
              // 添加调试输出
// 处理合同商品列表 - 优先使用contractItems，然后是materials_list等其他字段
              if (contractData.contractItems && Array.isArray(contractData.contractItems)) {
                this.contractItems = contractData.contractItems.map((item, index) => {
                  return {
                    category: item.remark || '',
                    index: index + 1,
                    material_name: item.productName || '',
                    spec_model: item.specification || '',
                    unit: item.unit || '',
                    quantity: item.quantity || '',
                    unit_price: item.unitPrice ? Number(item.unitPrice).toFixed(2) : '0.00',
                    tax_rate: item.taxRate || '0',
                    tax_price: item.totalAmount ? Number(item.totalAmount).toFixed(2) : '0.00'
                  };
                });
} else if (contractData.materials_list && Array.isArray(contractData.materials_list)) {
                this.contractItems = contractData.materials_list.map((item, index) => {
                  return {
                    category: item.remark || '',
                    index: index + 1,
                    material_name: item.materials_name || item.material_name || '',
                    spec_model: item.materials_spec || item.spec_model || '',
                    unit: item.unit || '',
                    quantity: item.quantity || '',
                    unit_price: item.before_price ? Number(item.before_price).toFixed(2) : (item.unit_price ? Number(item.unit_price).toFixed(2) : '0.00'),
                    tax_rate: item.tax_rate || '0',
                    tax_price: item.price ? Number(item.price).toFixed(2) : (item.tax_price ? Number(item.tax_price).toFixed(2) : '0.00')
                  };
                });
} else if (contractData.contract_list && Array.isArray(contractData.contract_list)) {
                this.contractItems = contractData.contract_list.map((item, index) => {
                  return {
                    category: item.remark || '',
                    index: index + 1,
                    material_name: item.materials_name || item.material_name || '',
                    spec_model: item.materials_spec || item.spec_model || '',
                    unit: item.unit || '',
                    quantity: item.quantity || '',
                    unit_price: item.before_price ? Number(item.before_price).toFixed(2) : (item.unit_price ? Number(item.unit_price).toFixed(2) : '0.00'),
                    tax_rate: item.tax_rate || '0',
                    tax_price: item.price ? Number(item.price).toFixed(2) : (item.tax_price ? Number(item.tax_price).toFixed(2) : '0.00')
                  };
                });
} else if (contractData.products && Array.isArray(contractData.products)) {
                this.contractItems = contractData.products.map((item, index) => {
                  return {
                    category: item.remark || '',
                    index: index + 1,
                    material_name: item.material_name || item.materials_name || '',
                    spec_model: item.spec_model || item.materials_spec || '',
                    unit: item.unit || '',
                    quantity: item.quantity || '',
                    unit_price: item.unit_price ? Number(item.unit_price).toFixed(2) : (item.before_price ? Number(item.before_price).toFixed(2) : '0.00'),
                    tax_rate: item.tax_rate || '0',
                    tax_price: item.tax_price ? Number(item.tax_price).toFixed(2) : (item.price ? Number(item.price).toFixed(2) : '0.00')
                  };
                });
} else if (contractData.items && Array.isArray(contractData.items)) {
                this.contractItems = contractData.items.map((item, index) => {
                  return {
                    ...item,
                    index: index + 1,
                    unit_price: item.unit_price ? Number(item.unit_price).toFixed(2) : '0.00',
                    tax_price: item.tax_price ? Number(item.tax_price).toFixed(2) : '0.00'
                  };
                });
}
              
            } catch (err) {
              console.error('处理合同数据时出错:', err);
              this.error = '处理合同数据时出错: ' + err.message;
            }
          } else {
            console.error('API返回错误:', response.data);
            this.error = response.data?.message || '获取合同数据失败';
          }
          
          this.loading = false;
        })
        .catch(error => {
          console.error('获取合同数据出错:', error);
          this.apiError = JSON.stringify(error, null, 2);
          this.error = '获取合同数据出错: ' + (error.response?.data?.message || error.message || '未知错误');
          this.loading = false;
        });
    },
    
    // 格式化付款方式
    formatPaymentMethod(contractData) {
      if (!contractData) return '未设置';
      
      let paymentMethod = '';
      
      // 添加调试输出
// 优先使用新的字段名
      if (contractData.payment70PercentDays) {
        paymentMethod = `${contractData.payment70PercentDays}天支付70%`;
        
        if (contractData.paymentFullDays) {
          paymentMethod += `，${contractData.paymentFullDays}天付至100%`;
        }
      } else if (contractData.payment1_daynum) {
        // 兼容旧的字段名
        paymentMethod = `每${contractData.payment1_daynum}天结算金额，次月最低支付70%`;
        
        if (contractData.payment2_daynum) {
          paymentMethod += `，${contractData.payment2_daynum}天结算金额付至100%`;
        }
      }
      
      // 如果有settlement_method或settlementMethod，添加到付款方式中
      const settlementInfo = contractData.settlementMethod || contractData.settlement_method;
      if (settlementInfo && !paymentMethod.includes(settlementInfo)) {
        if (paymentMethod) paymentMethod += '，';
        paymentMethod += settlementInfo;
      }
      
      // 调试最终结果
return paymentMethod || '未设置';
    },
    
    // 格式化计息条件
    formatInterestCondition(contractData) {
      if (!contractData) return '未设置';
      
      // 添加调试输出
let interestCondition = '';
      
      // 免息期 - 优先使用新字段名
      const interestFreeDays = contractData.interestFreeDays || contractData.interestfree_maxday;
      if (interestFreeDays) {
        interestCondition = `免息期：${interestFreeDays}天`;
      }
      
      // 检查是否计息
      const isInterestCalculation = contractData.interestCalculation || (contractData.is_measured !== '否');
      
      if (!isInterestCalculation) {
        if (interestCondition) interestCondition += '；';
        interestCondition += '不计息';
return interestCondition || '不计息';
      }
      
      // 首先检查是否有变动利率 - 最高优先级
      if (contractData.variable_rates && Array.isArray(contractData.variable_rates) && contractData.variable_rates.length > 0) {
        if (interestCondition) interestCondition += '；';
        interestCondition += '变动利率：';
        
        // 按date_max排序
        const sortedRates = [...contractData.variable_rates].sort((a, b) => 
          parseInt(a.date_max) - parseInt(b.date_max)
        );
        
// 添加所有变动利率
        const rateStrings = sortedRates.map(rate => 
          `${rate.date_max}天${rate.rate}%`
        );
        
        interestCondition += rateStrings.join('，');
return interestCondition;
      }
      
      // 然后检查是否有固定利率且不为0 - 优先使用新字段名
      const fixedRate = contractData.fixedInterestRate || contractData.fixed_rate;
      if (fixedRate && fixedRate !== '0' && fixedRate !== '0.00') {
        if (interestCondition) interestCondition += '；';
        interestCondition += `固定利率：${fixedRate}%`;
return interestCondition;
      }
      
return interestCondition || '未设置利率';
    },
    
    // 格式化计价方式
    formatPricingMethod(method) {
      const methodMap = {
        'FIXED': '固定价',
        'MARKET': '市场价',
        'NEGOTIATED': '协商价',
        'fixed': '固定价',
        'market': '市场价',
        'negotiated': '协商价',
        '固定价': '固定价',
        '变动价': '变动价'
      };
      return methodMap[method] || method || '未设置';
    },
    
    // 确认合同
    confirmContract() {
      this.$confirm('确认接受此合同并修改状态为"执行中"?', '确认合同', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        // 调用API更新合同状态
        this.loading = true;
        
        updateContractStatus(this.contractId, 'EXECUTING')
        .then(response => {
          if (response.data && response.data.success) {
            this.$message.success('合同已确认，状态已更新为"执行中"');
            // 返回上一页或刷新数据
            setTimeout(() => {
              this.goBack();
            }, 1500);
          } else {
            this.$message.error(response.data.message || '更新合同状态失败');
          }
        })
        .catch(error => {
          console.error('更新合同状态出错:', error);
          this.$message.error('更新合同状态失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        })
        .finally(() => {
          this.loading = false;
        });
      }).catch(() => {
        // 用户取消操作
        this.$message.info('已取消确认操作');
      });
    },
    
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    
    // 打印合同
    async printContract() {
      // 创建一个新窗口用于打印
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        this.$message.error('打印窗口被阻止，请允许弹出窗口');
        return;
      }
      
      // 获取当前合同内容
      const contractContent = document.querySelector('.supplier-contract-preview-container .contract-content');
      if (!contractContent) {
        this.$message.error('未找到合同内容');
        return;
      }
      
      // 获取合同内容的HTML
      const contentHTML = contractContent.innerHTML;
      
      // 写入打印窗口基本HTML结构
      printWindow.document.open();
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>${this.contractInfo.title || '供应商合同'}</title>
          <meta charset="utf-8">
          <style>
            body {
              font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
              color: #333;
              line-height: 1.5;
              padding: 20px;
              margin: 0;
            }
            
            .contract-title {
              text-align: center;
              font-size: 22px;
              font-weight: 500;
              margin: 20px 0 30px;
            }
            
            .section-title {
              border-bottom: 2px solid #000;
              margin: 30px 0 15px;
            }
            
            .section-title h3 {
              font-size: 16px;
              font-weight: 500;
              margin: 0 0 5px 0;
            }
            
            .contract-table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 30px;
            }
            
            .contract-table th, 
            .contract-table td {
              border: 1px solid #000;
              padding: 8px;
              text-align: center;
            }
            
            .contract-table th {
              background-color: #f5f7fa;
              font-weight: 500;
            }
            
            .info-table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 30px;
            }
            
            .info-table td {
              border: 1px solid #000;
              padding: 12px 15px;
            }
            
            .info-label {
              width: 10%;
              background-color: #f5f7fa;
              font-weight: 500;
            }
            
            .info-value {
              width: 23.3%;
            }
            
            @page {
              size: A4 portrait;
              margin: 1cm;
            }
            
            .print-controls {
              text-align: center;
              margin: 20px 0;
              padding: 10px;
              background-color: #f5f7fa;
              border-radius: 4px;
            }
            
            .print-controls button {
              padding: 6px 16px;
              background-color: #409EFF;
              color: white;
              border: none;
              border-radius: 4px;
              cursor: pointer;
              margin: 0 5px;
              font-size: 14px;
            }
            
            .print-controls button:hover {
              background-color: #66b1ff;
            }
            
            .print-controls .close-btn {
              background-color: #909399;
            }
            
            .print-note {
              font-size: 12px;
              color: #606266;
              margin-top: 5px;
            }
            
            @media print {
              .print-controls {
                display: none;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-controls">
            <button onclick="doPrint()">打印</button>
            <button class="close-btn" onclick="window.close()">关闭窗口</button>
            <div class="print-note">打印完成后窗口将在60秒后自动关闭，或点击"关闭窗口"按钮手动关闭</div>
          </div>
          
          <div id="contract-content"></div>
        </body>
        </html>
      `);
      
      await installPlatformPrintFooter(printWindow, null, {
        documentType: 'CONTRACT',
        documentKey: this.contractId
      });
      // 关闭文档流
      printWindow.document.close();
      
      // 在窗口加载完成后注入内容和处理打印
      printWindow.onload = function() {
        // 设置合同内容
        printWindow.document.getElementById('contract-content').innerHTML = contentHTML;
        
        // 添加脚本
        const script = printWindow.document.createElement('script');
        script.textContent = `
          function doPrint() {
            window.print();
          }
          
          // 页面加载完成自动打印
          window.addEventListener('load', function() {
            window.focus();
            
            // 延迟打印，确保内容已加载
            setTimeout(function() {
              window.print();
            }, 500);
            
            // 60秒后自动关闭窗口
            setTimeout(function() {
              window.close();
            }, 60000);
          });
          
          // 尝试监听打印完成事件
          if (window.matchMedia) {
            const mediaQueryList = window.matchMedia('print');
            mediaQueryList.addEventListener('change', function(mql) {
              if (!mql.matches) {
                // 打印对话框已关闭，5秒后关闭窗口
                setTimeout(function() {
                  window.close();
                }, 5000);
              }
            });
          }
        `;
        printWindow.document.body.appendChild(script);
      };
    },
    // 格式化税率显示（添加%符号）
    formatTaxRate(value) {
      if (value === null || value === undefined || value === '') return '0%';
      const num = parseFloat(value);
      if (isNaN(num)) return '0%';
      // 如果值小于1，说明是小数形式（如0.13），转换为百分比形式（13）
      if (num < 1 && num > 0) {
        return `${Math.round(num * 100)}%`;
      }
      // 如果值大于等于1，说明已经是百分比形式（如13），直接返回
      return `${Math.round(num)}%`;
    }
  }
};
</script>

<style lang="scss" scoped>
.supplier-contract-preview-container {
  background-color: #fff;
  padding: 0;
  min-height: calc(100vh - 120px);
  
  .debug-panel {
    background-color: #fff8e1;
    border: 1px solid #ffecb3;
    padding: 15px;
    margin: 20px;
    border-radius: 4px;
    
    h3 {
      margin-top: 0;
      color: #ff9800;
    }
    
    p {
      margin: 5px 0;
      font-family: monospace;
      word-break: break-all;
      font-size: 14px;
    }
    
    .debug-actions {
      margin-top: 15px;
    }
  }
  
  .loading-container {
    margin: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  
  .contract-content {
    padding: 40px 20px 0; /* 增加上边距，将内容往下移 */
  }
  
  .contract-title {
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    margin: 30px 0;
  }
  
  .section-title {
    border-bottom: 2px solid #000;
    margin: 30px 0 15px;
    
    h3 {
      font-size: 16px;
      font-weight: 500;
      margin: 0 0 5px 0;
    }
  }
  
  .table-container {
    width: 100%;
    overflow-x: auto;
    margin-bottom: 30px;
  }
  
  .contract-table {
    width: 100%;
    border-collapse: collapse;
    
    th, td {
      border: 1px solid #ddd;
      padding: 8px;
      text-align: center;
    }
    
    th {
      background-color: #f5f7fa;
      font-weight: 500;
      color: #606266;
    }
    
    tr:nth-child(even) {
      background-color: #fafafa;
    }
  }
  
  .info-container {
    margin-bottom: 30px;
  }
  
  .info-table {
    width: 100%;
    border-collapse: collapse;
    
    td {
      border: 1px solid #ddd;
      padding: 12px 15px;
    }
    
    .info-label {
      width: 10%;
      background-color: #f5f7fa;
      font-weight: 500;
      color: #606266;
    }
    
    .info-value {
      width: 23.3%;
      color: #333;
    }
  }
  
  .action-buttons {
    margin: 30px 0;
    text-align: center;
    
    .el-button {
      min-width: 100px;
      margin: 0 10px;
    }
  }
  
  /* 打印样式 */
  @media print {
    /* 隐藏不需要打印的元素 */
    .action-buttons, .debug-panel {
      display: none !important;
    }
    
    /* 表格分页控制 */
    .info-container, .contract-table {
      page-break-inside: avoid;
    }
    
    /* 调整页面边距和背景 */
    .supplier-contract-preview-container {
      padding: 0 !important;
      margin: 0 !important;
      background-color: white !important;
    }
    
    /* 打印时隐藏滚动条 */
    ::-webkit-scrollbar {
      display: none !important;
    }
    
    /* 调整表格边框颜色 */
    .contract-table th, .contract-table td,
    .info-table td {
      border-color: #000 !important;
    }
  }
}
</style>
